<template>
  <Modal
    v-model="modal.value"
    :title="selfModal.title"
    :width="selfModal.width"
    @on-ok="onModalConfirm"
  >
    <Form
      :label-width="80"
      :model="validateValue"
      :rules="ruleValidate"
      @submit.native.prevent
    >
      <div v-for="(item, index) in cloneFormOption" :key="item.name || index">
        <FormItem
          :prop="item.type"
          :label-width="item.labelWidth"
          v-if="item.__show"
        >
          <!-- form-item label -->
          <span class="form-item_title" slot="label">{{ item.title }}</span>
          <!-- input -->
          <Input
            v-if="item.type === 'input'"
            class="form-input"
            v-model="item.value"
            :size="item.size"
            :type="item.inputType"
            :clearable="item.clearable"
            :placeholder="item.placeholder"
            :disabled="item.disabled"
            :readonly="item.readonly"
            :maxlength="item.maxlength"
            :icon="item.icon"
            :prefix="item.prefix"
            :suffix="item.suffix"
            :search="item.search"
            :enter-button="item.enterButton"
            :rows="item.rows"
            :autosize="item.autosize"
            :number="item.number"
            :autofocus="item.autofocus"
            :autocomplete="item.autocomplete"
            :spellcheck="item.spellcheck"
            :wrap="item.wrap"
            @on-search="onInputSearch"
          />

           <!-- input-number-->
          <InputNumber
            v-if="item.type === 'input-number'"
            class="form-input-number"
            v-model="item.value"
            :max="item.max"
            :min="item.min"
          />

          <!-- AutoComplete -->
          <AutoComplete
            v-if="item.type === 'auto-complete'"
            v-model="item.value"
            :data="item.data"
            :clearable="item.clearable"
            :disabled="item.disabled"
            :placeholder="item.placeholder"
            :size="item.size"
            :icon="item.icon"
            :transfer="item.transfer"
            :element-id="item.elementId"
            :label-in-value="true"
            @on-change="onAutoCompleteSearch(item, $event)"
            @on-select="onAutoCompleteSelect(item, $event)"
          ></AutoComplete>

          <!-- radio -->
          <RadioGroup
            v-if="item.type === 'radio'"
            v-model="item.value"
            :vertical="item.vertical"
            @on-change="onRadioChange(item, $event)"
          >
            <Radio
              class="radio-item"
              v-for="_radio in item.list"
              :key="_radio.label"
              :label="_radio.label"
              :disabled="_radio.disabled"
              :size="_radio.size"
              :border="_radio.border"
              :true-value="_radio.trueValue"
              :false-value="_radio.falseValue"
            ></Radio>
          </RadioGroup>

          <!-- 选择器 -->
          <Select
            class="form-select"
            v-if="item.type === 'select'"
            v-model="item.value"
            :size="item.size"
            :multiple="item.multiple"
            :disabled="item.disabled"
            :clearable="item.clearable"
            :filterable="item.filterable"
            :placeholder="item.placeholder"
            :not-found-text="item.notFoundText"
            :label-in-value="item.labelInValue"
            @on-change="onSelectChange"
          >
            <Option
              v-for="op in item.data"
              :key="op.value"
              :value="op.value"
              :label="op.label"
              >{{ op.label }}</Option
            >
          </Select>

          <!-- 地图 -->
          <!-- 为了保证每次进入地图都会初始化，组件的销毁挂载与modal保持一致 -->
          <section v-if="item.type === 'map' && modal.value">
            <div v-if="item.value" class="address" @click="showmap()">
              {{ item.value }}
            </div>
            <div v-else @click="showmap()" class="address address_nodata">
              请选择地点
            </div>
            <map-modal
              v-if="showMap"
              @confirm="getAddress($event, item)"
              @cancel="showmap"
              :zuobiao="{
                label: item.value,
                value: item.value?(item.longitude + ',' + item.latitude):''
              }"
            ></map-modal>
          </section>

          <!-- 图片上传 -->
          <upload-img
            v-if="item.type === 'upload-img'"
            :imgArr="item.imgArr"
            :imgWidth="item.imgWidth"
            :imgHeight="item.imgHeight"
            @saveImg="uploadImgSave(item, $event)"
            @delPic="uploadImgDel(item, $event)"
            :imgNumber="item.imgNumber"
            :fixedNumber="item.fixedNumber"
          >
            <div class="iconfont icon-shangchuan1 img-add"></div>
          </upload-img>

          <!-- 头像上传 特定的业务组件 -->
          <div class="form-avatar" v-if="item.type === 'avatar'">
            <img
              class="form-avatar_img"
              :src="item.src || require('@/assets/images/default.png')"
              title="用户头像"
            />
            <div class="form-avatar_option">
              <!-- 编辑 -->
              <i class="iconfont icon-bianji1" @click="avatarClick(item)"></i>
              <input
                :ref="item.name"
                type="file"
                accept="image/png, image/jpeg, image/gif, image/jpg"
                @change="avatarChange(item, index, $event)"
                hidden
              />
              <!-- imgAee imgNumber 非必须参数 只是不传会报错 -->
              <upload-img
                :imgArr="[]"
                :isClick="item.isClick"
                :isClickE="item.isClickE"
                :fixedNumber="[1, 1]"
                :imgNumber="1"
                @saveImg="avatarSave(item, $event)"
              ></upload-img>
            </div>
          </div>

          <!-- 人员选择 特定业务组件-->
          <div
            class="form-search-picker"
            v-if="item.type === 'search-picker'"
            v-show="item.list.length"
            :class="{ 'form-search-picker--scroll': item.scroll }"
            :style="item.scroll && { maxHeight: item.scrollHeight + 'px' }"
            @scroll="throttleOnFormSearchPickerScroll(item, $event)"
          >
            <div
              class="sp_item"
              :class="{ 'sp_item--selected': person.selected }"
              v-for="person in item.list"
              :key="person.key"
              @click="onSearchPickerClick(person, item)"
            >
              <img
                class="sp_item_img"
                :src="person.imgUrl || require('@/assets/images/default.png')"
              />
              <span>{{ person.realName }}</span>
              <span>{{ person.nickName }}</span>
            </div>
          </div>
        </FormItem>
      </div>
    </Form>

    <Spin v-show="showSpin" fix size="large"></Spin>
  </Modal>
</template>

<script>
import uploadImg from "@/components/uploadImg";
import mapModal from "./mapModal";

// 基本类目字段 title name type

// 支持组件类型
const TYPE = [
  "input",
  "radio",
  "select",
  "map",
  "upload-img",
  "auto-complete",
  "avatar",
  "search-picker",
  "input-number"
];
// modal 默认值
const MODAL = {
  value: false,
  title: "",
  width: 700,
  closable: true
};
// input 默认配置项
// 2019年10月18日 没有扩展4.0+默认项
const INPUT = {
  inputType: "text",
  __show: true, // 是否显示组件
  value: "",
  size: "default",
  placeholder: "请输入",
  clearable: false,
  disabled: false,
  readonly: false,
  maxlength: -1,
  icon: "",
  prefix: "",
  suffix: "",
  search: false,
  enterButton: false,
  rows: 4,
  autosize: false,
  number: false,
  autofocus: false,
  autocomplete: "off",
  elementId: "",
  spellcheck: false,
  wrap: "soft"
};

// inputnumber 默认配置项
// wxf-2020-11-17
const INPUTNUMBER = {
  __show: true, // 是否显示组件
  value: "",
  max: Infinity,
  min:-Infinity,
};

// raido 只支持 group 使用
const RADIO = {
  __show: true, // 是否显示组件
  value: "",
  radioType: "",
  size: "",
  vertical: false,
  list: []
};
// select
const SELECT = {
  __show: true, // 是否显示组件
  value: "",
  data: [],
  multiple: false,
  disabled: false,
  clearable: false,
  filterable: false,
  labelInValue: false,
  size: "default",
  placeholder: "请选择",
  notFoundText: "无匹配数据"
};

// AutoComplete
const AUTOCOMPLETE = {
  __show: true, // 是否显示组件
  value: "",
  data: [],
  originData: [], // 用于存放原始数据 组件data只能放String
  clearable: false,
  disabled: false,
  placeholder: "请输入搜索",
  size: "default",
  icon: "ios-search",
  filterMethod: false,
  placement: "bottom-start",
  transfer: false,
  elementId: ""
};

/* map 默认项 */
class AMAP {
  constructor() {
    this.__show = true; // 是否显示组件
    this.value = "";
    this.longitude = ""; // 坐标值 表单值
    this.latitude = ""; // 坐标值

    this.hideMap = true; // 隐藏地图
    this.placeholder = "点击图标进行坐标选择";
    this.zoom = 12;
    this.center = [116.397451, 39.909187];
    this.marker = [116.397451, 39.909187];

    this.plugin = [
      {
        pName: "Geocoder",
        events: {
          init(o) {
            AMAP.Geocoder = o; // 逆地理解析插件实例
          }
        }
      }
    ];
    this.events = {
      init(o) {},
      // 地图点击事件
      click: e => {
        // 打点
        this.marker = [e.lnglat.lng, e.lnglat.lat];
        // 更新坐标值
        this.longitude = e.lnglat.lng;
        this.latitude = e.lnglat.lat;
        // 逆地理解析 并 赋值
        AMAP.Geocoder.getAddress([e.lnglat.O, e.lnglat.P], (status, result) => {
          if (status === "complete" && result.info === "OK") {
            this.value = result.regeocode.formattedAddress;
          }
        });
      }
    };
  }
}
// 定义静态属性 高德插件不会重复初始化
AMAP.Geocoder = null;

// 头像 默认像
const AVATAR = {
  __show: true, // 是否显示组件
  value: "", // 存储头像的链接
  src: "",
  name: "avatarInput", // 默认input ref
  isClick: 0,
  isClickE: {}
};
// 图片上传
const UPLOADIMG = {
  __show: true, // 是否显示组件
  imgArr: [],
  imgWidth: 100,
  imgHeight: 62,
  imgNumber: 100, // 图片数量
  fixedNumber: [8, 5] // 图片裁剪比例
};

// list-item 基本结构
// {imgUrl,realName,nickName,selected}
// 人员搜索并选择
const SEARCH_PICKER = {
  __show: true,
  single: true,
  scroll: true, // 是否开启滚动分页
  scrollHeight: 400, // 滚动的高度
  labelWidth: 0, // no label
  list: []
};
/* 初始化组件 */
function initComponent(item) {
  switch (item.type) {
    case "input":
      return Object.assign({}, INPUT, item);

    case "radio":
      return Object.assign({}, RADIO, item);

    case "map":
      return Object.assign(new AMAP(), item);

    case "avatar":
      return Object.assign({}, AVATAR, item);

    case "auto-complete":
      return Object.assign({}, AUTOCOMPLETE, item);

    case "select":
      return Object.assign({}, SELECT, item);

    case "upload-img":
      return Object.assign({}, UPLOADIMG, item);

    case "search-picker":
      return Object.assign({}, SEARCH_PICKER, item);

    case "input-number":
      return Object.assign({},INPUTNUMBER,item)

    default:
      throw new Error(`form_modal 未匹配到配置 ${item.type}`);
  }
}

export default {
  components: { uploadImg, mapModal },
  props: {
    // 弹窗的配置项
    modal: {
      type: Object,
      default() {
        return MODAL;
      }
    },
    // 表单配置项
    formOption: {
      type: Array,
      default() {
        return [];
      },
      validator(value) {
        for (let item of value) {
          if (!("type" in item)) {
            throw new Error("form-modal配置项必须包含type属性");
          }

          if (!TYPE.includes(item.type)) {
            throw new Error(
              "form-modal配置项type支持的范围为: " + TYPE.toString()
            );
          }
        }
        return true;
      }
    }
  },
  data() {
    /* 地图组件 默认校验 */
    const validateMap = (rule, value, callback) => {
      callback();
    };
    return {
      zuobiao: {}, //wxf 地图弹出框是否显示
      showMap: false, //wxf 地图弹出框是否显示
      showSpin: false,
      cloneFormOption: [], // 表单的配置项
      /* 组件值校验 */
      ruleValidate: {
        map: [{ validator: validateMap, trigger: "change" }]
      }
    };
  },
  watch: {
    formOption: {
      handler(val) {
        this.cloneFormOption = this._.cloneDeep(val).map(item =>
          initComponent(item)
        );
      },
      immediate: true
    }
  },
  computed: {
    selfModal() {
      return Object.assign({}, MODAL, this.modal);
    },
    validateValue() {
      let res = {};
      // 校验数据项 初始化
      this.cloneFormOption.forEach(item => {
        res[item.type] = item.value;
      });
      return res;
    }
  },
  methods: {
    showLoading() {
      this.showSpin = true;
    },
    hideLoading() {
      this.showSpin = false;
    },
    /**wxf-地图相关 */
    showmap() {
      this.showMap = !this.showMap;
    },
    getAddress(val, item) {
      item.value = val.label;
      item.longitude = val.value.split(",")[0];
      item.latitude = val.value.split(",")[1];
      //this.coordinate = val.value
      this.showmap();
    },
    /* modal 确定 */
    onModalConfirm() {
      let tmp = new Map();
      this.cloneFormOption.forEach((item, index) => {
        tmp.set(item.name || item.type + index, item);
      });
      this.$emit("on-ok", tmp);
    },
    onInputSearch(e) {
      this.$emit("input-on-search", e);
    },
    // 点击头像上传
    avatarClick(item) {
      this.$refs[item.name][0].click();
    },
    // input 发生变化
    avatarChange(item, index, event) {
      ++item.isClick;
      item.isClickE = event;
      this.cloneFormOption.splice(index, 1, item);
    },
    /* 头像上传 */
    avatarSave(item, event) {
      item.value = event;
      item.src = event.path;
      // 清空当前组件对应input 的file值 以便对于同一个图片触发change事件
      this.$refs[item.name][0].value = "";
    },
    /* 图片上传 保存*/
    uploadImgSave(item, event) {
      // 项目接口字段问题 格式化 为 picId
      item.imgArr.push({
        picId: event.id,
        path: event.path
      });
    },
    /* 图片上传 删除 */
    uploadImgDel(item, event) {
      // 删除图片
      this.showLoading();
      this.$post(this.urlobj.getSysPic(), { id: event.id })
        .then(res => {
          if (!res.isSucceed) return this.$Message.error(res.message);
          item.imgArr.splice(event.index, 1);
        })
        .catch(e => new Error(e))
        .finally(this.hideLoading);
    },
    /* select 发生变化 */
    onSelectChange(event) {
      this.$emit("select-on-change", event);
    },
    /* 自动填充组件搜索 */
    onAutoCompleteSearch(item, event) {
      let data = item.params;

      // 关联不同参数字段的值
      if ("valueRelated" in data) {
        data[data.valueRelated] = event;
      }

      this.$post(item.url, data).then(res => {
        if (res.isSucceed) {
          item.originData = res.rows; // 存放原始数据
          // 避免用户重名
          let tmpSet = new Set();
          res.rows.forEach(item => {
            if (tmpSet.has(item.userName))
              return tmpSet.add(`${item.userName}-${item.id}`);

            tmpSet.add(item.userName);
          });
          if (data.userName) {
            item.data = [...tmpSet];
          } else {
            item.data = [];
          }
        }

        if (res.rows.length == 1 && data.userName == res.rows[0].userName) {
          this.$emit("autocomplete-on-select", res.rows[0]);
        }
      });
    },
    /* 自动填充组件 选择 组件特质决定 */
    onAutoCompleteSelect(item, event) {
      let res = item.originData.filter(item => {
        return (
          event === item.userName || event === `${item.userName}-${item.id}`
        );
      })[0];
      this.$emit("autocomplete-on-select", res);
    },
    /* radio change */
    onRadioChange(item, event) {
      let [res] = item.list.filter(item => item.label === event);
      this.$emit("radio-on-change", res);
    },

    onSearchPickerClick(person, item) {
      if (item.single) {
        if (person.selected) return;
        let _person = this._.cloneDeep(person),
          _index;
        _person.selected = true;

        item.list.forEach((tmp, index) => {
          tmp.selected = false;
          if (tmp === person) _index = index;
        });
        item.list.splice(_index, 1, _person);
      } else {
        person.selected = !person.selected;
      }

      this.$emit(
        "search-picker-on-change",
        item.list.filter(item => item.selected)
      );
    },
    onFormSearchPickerScroll(item, event) {
      let { scrollHeight, scrollTop } = event.target;
      if (scrollHeight - scrollTop === item.scrollHeight) {
        this.$emit("search-picker-onreachbottom");
      }
    }
  },
  created() {},
  mounted() {
    // AutoComplete 节流操作 1秒触发一次
    this.throttleAutoCompleteSearch = this._.throttle(
      this.onAutoCompleteSearch,
      1000
    );
    // 搜索滚动事件 防抖
    this.throttleOnFormSearchPickerScroll = this._.debounce(
      this.onFormSearchPickerScroll,
      500
    );
  },
  beforeDestroy() {}
};
</script>
<style lang="less" scoped>
.form-item {
  .flex(center);
  margin: 15px 0;
}
.form-item_title {
  font-size: 16px;
  color: #333;
}

/* radio */
.radio-item {
  margin-right: 20px;
}

/* 图片上传 */
.img-add {
  color: #bbbbbb;
  border: 1px solid #bbb;
  text-align: center;
  line-height: 42.5px;
  height: 62.5px;
  width: 100px;
  position: relative;
  padding-top: 10px;

  cursor: pointer;
}

/* 头像编辑 */
.form-avatar {
  position: relative;
  width: 0.8rem;
  height: 0.8rem;
  border: 1px solid #c7c7c7;
  border-radius: 50%;
  &:hover .form-avatar_option {
    .flex(center, center);
  }
}
.form-avatar_img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.form-avatar_option {
  display: none;
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  .icon-bianji1 {
    color: #fff;
    font-size: 24px;
    cursor: pointer;
  }
}

/*选择地点的样式*/
.address {
  width: 100%;
  height: 32px;
  line-height: 24px;
  padding: 4px 7px;
  font-size: 12px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  color: #515a6e;
  background-color: #fff;
  background-image: none;
  position: relative;
  cursor: text;
}
.address_nodata {
  color: #bbb;
}
.address:hover {
  border: 1px solid #ff7b44;
}
.address:active {
  border: 1px solid #ff7b44;
}

/* 人员选择 */
.form-search-picker {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  grid-auto-rows: auto;
  grid-gap: 30px;

  justify-items: center;

  &--scroll {
    overflow-y: scroll;
    padding-top: 10px;

    scrollbar-width: 5px;

    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: darkgrey;
      outline: 1px solid slategrey;
    }
  }
}
.sp_item {
  .flex(center, center, @flexDirection:column);
  width: 118px;
  height: 148px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-size: 14px;
  color: #4b4b4b;
  cursor: default;

  &:hover {
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  }

  .sp_item_img {
    position: relative;
    width: 50px;
    height: 50px;
    border-radius: 50%;

    margin-bottom: 10px;

    &:not([src]) {
      opacity: 0;
    }
  }
}
.sp_item--selected {
  position: relative;
  border-color: #ff7b44;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background-color: #ff7b44;
    transform: translate(50%, -50%);
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 4px;
    height: 8px;
    border: 1px solid #fff;
    border-left: none;
    border-top: none;
    transform: translate(50%, -60%) rotate(45deg);
  }
}

.form-input-number{
  width:100%
}
</style>
